
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/keycloak-alternative",
      function () {
        return require("private-next-pages/compare/keycloak-alternative.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/keycloak-alternative"])
      });
    }
  